module.exports = __webpack_public_path__ + "img/logo_ft.9ab5b31c.png";